import { useEffect, useState } from 'react';
import { usePromiseTracker, trackPromise } from 'react-promise-tracker';
import { Box, Button, CircularProgress, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useSnackbar } from 'notistack';

import fetchJobOfferings from '../http/fetchJobOfferings';
import JobOfferingCard from '../components/JobOfferingCard';
import MarkdownPage from '../components/MarkdownPage';
import JobOfferingDto from '../model/jobOfferingDto';

const INITIATIVE_APPLICATION_URL =
  'https://phatconsulting.onapply.de/details/348615.html';

const useStyles = makeStyles(() => ({
  // Outline button of phatconsulting.de ("mehr Kunden", "mehr Insiderwissen")
  directApplyBtn: {
    textTransform: 'none',
    padding: '6px 12px',
    fontSize: '18px',
    lineHeight: 1.25,
    fontFamily: 'DIN2014-Regular, Helvetica, Arial, sans-serif',
    fontWeight: 'normal',
    color: '#fff',
    border: '1px solid #fff',
    borderRadius: 0,
    '&:hover': {
      border: '1px solid #fff',
      background: '#fff',
      color: '#344853',
    },
  },
}));

const JobOffers = (): JSX.Element => {
  const [jobOfferings, setJobOfferings] = useState<JobOfferingDto[]>([]);
  const { promiseInProgress } = usePromiseTracker({ delay: 500 });
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const loadJobOfferings = async () => {
      try {
        setJobOfferings(await fetchJobOfferings());
      } catch {
        enqueueSnackbar('Die Stellen konnten gerade nicht geladen werden.', {
          variant: 'error',
        });
      }
    };

    trackPromise(loadJobOfferings());
  }, [enqueueSnackbar]);

  // Intro above the cards (People's wish), cards and button below, styled like phatconsulting.de.
  return (
    <Box>
      <Box sx={{ marginBottom: '40px' }}>
        <MarkdownPage name="startseite" variant="dark" />
      </Box>
      {promiseInProgress ? (
        <Grid justifyContent="center" sx={{ marginTop: '40px' }} container>
          <CircularProgress color="primary" />
        </Grid>
      ) : (
        <Grid spacing={4} container>
          {jobOfferings.map((jobOffering) => (
            <JobOfferingCard key={jobOffering.OfferingId} jobOffering={jobOffering} />
          ))}
        </Grid>
      )}
      <Grid justifyContent="flex-start" sx={{ marginTop: '40px' }} container>
        <Button className={classes.directApplyBtn} href={INITIATIVE_APPLICATION_URL} variant="outlined">
          Nichts passendes gefunden? Initiativbewerbung
        </Button>
      </Grid>

      <Box height="70px" />
    </Box>
  );
};

export default JobOffers;
